import { apiSigningFetch } from '..';

export type PostDocumentsAgreementResponse = {
  documentId: string;
  providerDocumentId: string;
  signingToken: string;
  signingUrl: string;
  title: string;
  isExisting: boolean;
  status: string;
  signingStatus: string;
  downloadUrl: string;
};

export const _postDocumentsAgreement = () => {
  return apiSigningFetch<PostDocumentsAgreementResponse>('/documents/agreement', {
    method: 'POST',
  });
};

export type PostInvestmentAgreementRequest = {
  templateId: number;
  fundName: string;
  investmentAmount: string;
  investmentRef?: string;
  /** BE defaults to 'InvestmentAgreement' when omitted. */
  documentType?: 'InvestmentAgreement' | 'InvestorEligibility';
};

export type PostInvestmentAgreementResponse = {
  documentId: string;
  providerDocumentId: string;
  signingToken: string;
  signingUrl: string;
  title: string;
};

export const _postInvestmentAgreement = (body: PostInvestmentAgreementRequest) => {
  return apiSigningFetch<PostInvestmentAgreementResponse>('/documents/investment-agreement', {
    method: 'POST',
    body,
  });
};
